import { CUSTOMER_PROFILE_CLEAN, CUSTOMER_PROFILE_ERROR_CLEAN } from '_models/redux/types';

export const cleanGetProfile = () => async (dispatch) => {
  try {
    dispatch({
      type: CUSTOMER_PROFILE_CLEAN,
      payload: [],
    });
  } catch (e) {
    dispatch({
      type: CUSTOMER_PROFILE_ERROR_CLEAN,
      payload: [],
    });
  }
};
